import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApp } from "@/context/AppContext";
import { showPin } from "@/lib/api";

export const DelegateSelect = ({ value, onChange, testId, list }) => {
  const { delegates } = useApp();
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-10" data-testid={testId}><SelectValue placeholder="Choose a participant" /></SelectTrigger>
      <SelectContent className="max-h-72">
        {(list || delegates).map((d) => (
          <SelectItem key={d.id} value={d.id}>{d.name} · <span className="font-mono text-xs">{showPin(d.pin)}</span></SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
